import * as React from 'react';

import { RenderSimpleHtml } from '@blockworks/ui/legacy/string';
import { cn } from '@blockworks/ui/utils';

import PrimaryButton from '@/components/display/buttons/primary-button';
import SecondaryButton from '@/components/display/buttons/secondary-button';

type HeroImage = {
    url: string;
    srcSet?: string[];
    height?: string;
};

type HeroProps = {
    className?: string;
    title: string;
    subTitle?: string;
    description?: string;
    buttonTitle?: string;
    buttonLink?: string;
    secondaryButtonTitle?: string;
    secondaryButtonLink?: string;
    image: HeroImage;
};

const Hero = (props: HeroProps) => {
    const {
        title,
        description,
        subTitle,
        className,
        buttonTitle,
        buttonLink,
        secondaryButtonLink,
        secondaryButtonTitle,
        image,
    } = props;

    return (
        <section
            className={cn(
                'flex flex-col lg:flex-row justify-center items-center self-stretch gap-10 bg-[#f7f7f7]',
                className,
            )}
        >
            <picture className="max-h-[450px] relative">
                <img
                    src={image.url}
                    srcSet={image.srcSet?.map((url, idx) => `${url} ${idx + 1}x`).join(', ')}
                    className="object-cover"
                    style={{ height: image.height || '400px' }}
                    alt="advertise-header-image"
                />
            </picture>
            <div className="flex flex-col justify-between items-center relative text-center lg:text-left ">
                <div className="flex flex-col justify-start items-start gap-4 max-w-lg px-6 lg:py-24">
                    {subTitle && <p className="w-full text-sm uppercase text-[#5637cd]">{subTitle}</p>}
                    <div className="flex flex-col justify-start items-start gap-3">
                        <h1 className="text-2xl md:text-3xl lg:text-4xl max-w-4xl font-semibold text-[#110b29]">
                            {title}
                        </h1>
                    </div>
                    {description && (
                        <p className="flex-grow-0 flex-shrink-0 text-lg text-[#110b29]">
                            <RenderSimpleHtml html={description} />
                        </p>
                    )}
                    <div className="flex flex-row gap-4 mb-12 mx-auto lg:mx-0">
                        {buttonTitle && buttonLink && (
                            <PrimaryButton
                                link={buttonLink}
                                className="uppercase"
                                rel="noreferrer"
                                target={buttonLink.indexOf('://') !== -1 ? '_blank' : ''}
                            >
                                {buttonTitle}
                            </PrimaryButton>
                        )}
                        {secondaryButtonTitle && secondaryButtonLink && (
                            <SecondaryButton
                                link={secondaryButtonLink}
                                className="uppercase border-primary text-primary"
                                rel="noreferrer"
                                target={secondaryButtonLink.indexOf('://') !== -1 ? '_blank' : ''}
                            >
                                {secondaryButtonTitle}
                            </SecondaryButton>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
